import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../const";
// @ts-ignore
import {SystemLogType} from "../../../../core/gd/const/system-log";

export default class SettingsCreateTaskByEmailLogs extends SettingsModule {

    constructor() {
        super({
            name                     : "Create Task by Email",
            description              : "",
            svgIcon                  : "isvg-logs",
            typeLabel                : "Organization account",
            settingsUrl              : `settings/logs-email-create-task/${SystemLogType.EMAIL_CREATE_TASK}`,
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });

        this.parentSection          = SettingsParentSection.SYSTEM

        this.canDisable             = false
        this.hasStatus              = false
    }

}
